import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { HelmetProvider } from "react-helmet-async"
import { RouterProvider } from "react-router-dom"

import { Suspense } from "react"
import router from "../router"
import Spinner from "./Spinner"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 100,
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <ReactQueryDevtools initialIsOpen={false} buttonPosition="top-right" />
        <Suspense fallback={<Spinner />}>
          <RouterProvider router={router} />
        </Suspense>
      </HelmetProvider>
    </QueryClientProvider>
  )
}

export default App
